import { render, staticRenderFns } from "./ExternalCostBasis.vue?vue&type=template&id=d35ffe3a&"
import script from "./ExternalCostBasis.vue?vue&type=script&lang=ts&"
export * from "./ExternalCostBasis.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports